import ValidationErrors from "@/components/inertia/validation-errors";
import { Alert, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Field, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import useTranslations from "@/hooks/use-translations";
import { registration_path } from "@/lib/routes";
import { Form, Link, usePage } from "@inertiajs/react";
import { AlertCircleIcon, ToyBrick } from "lucide-react";

export default function SignUp() {
  const { flash } = usePage().props;
  const { t } = useTranslations("site.sign_up");

  return (
    <section className="min-h-screen bg-secondary px-8 pt-24">
      <div className="mx-auto flex w-full flex-col gap-8 max-w-90">
        <div className="flex flex-col items-center gap-6 text-center">
          <ToyBrick className="size-8" />
          <div className="flex flex-col gap-3">
            <h1 className="text-3xl font-semibold">{t("title")}</h1>
            <p className="self-stretch p-0 text-md text-tertiary">
              {t("tagline")}
            </p>
          </div>
        </div>

        <Form
          action={registration_path()}
          method="post"
          className="flex flex-col gap-6"
        >
          {(form) => (
            <>
              {flash.alert && (
                <Alert variant="destructive">
                  <AlertCircleIcon />
                  <AlertTitle>{flash.alert}</AlertTitle>
                </Alert>
              )}
              <div className="flex flex-col gap-5">
                <Field data-invalid={!!form.errors["email"]}>
                  <FieldLabel htmlFor="email">{t("email_label")}</FieldLabel>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder={t("email_placeholder")}
                    className="bg-white"
                    aria-invalid={!!form.errors["email"]}
                  />
                  {form.errors["email"] && (
                    <ValidationErrors errors={form.errors["email"]} />
                  )}
                </Field>

                <Field data-invalid={!!form.errors["password"]}>
                  <FieldLabel htmlFor="password">
                    {t("password_label")}
                  </FieldLabel>
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="••••••••"
                    className="bg-white"
                    aria-invalid={!!form.errors["password"]}
                  />
                  {form.errors["password"] && (
                    <ValidationErrors errors={form.errors["password"]} />
                  )}
                </Field>
              </div>

              <Button type="submit" size="lg">
                {t("submit")}
              </Button>
            </>
          )}
        </Form>

        <p className="flex justify-center gap-1 text-center items-center text-sm">
          {t("has_account")}{" "}
          <Button asChild variant="link">
            <Link href="/sign_in">{t("log_in")}</Link>
          </Button>
        </p>
      </div>
    </section>
  );
}
